/** Подписи архива досок. */

import { SYSTEM_TIME_ZONE } from "@/shared/lib/date";

/** «1 задача», «3 задачи», «5 задач». */
export function tasksCount(count: number): string {
  const tens = count % 100;
  const units = count % 10;
  const word =
    tens >= 11 && tens <= 14
      ? "задач"
      : units === 1
        ? "задача"
        : units >= 2 && units <= 4
          ? "задачи"
          : "задач";
  return `${String(count)} ${word}`;
}

/** Дата и время архивации по Москве: «17.09.2026, 14:05». Время системы —
 *  московское, как и подписи, которые формирует сервер, — а не часовой пояс браузера. */
export function formatArchivedAt(iso: string): string {
  const date = new Date(iso);
  return Number.isNaN(date.getTime())
    ? iso
    : date.toLocaleString("ru-RU", {
        dateStyle: "short",
        timeStyle: "short",
        timeZone: SYSTEM_TIME_ZONE,
      });
}
